<template>
	<div class="independent-wrapper">
		<div class="content">
			<div class="title">
				<span class="border"></span>
				<i class="el-icon-location-outline"></i> 知识库管理 > 药食管理
			</div>
			<div class="contentLeft">
				<div class="tab-container tab">
					<ul>
						<li v-for="(item, index) in tabList" :key="index" :class="{ active: currentTabIndex == index }"
							@click="goOther(index, item.id)">
							{{ item.name }}
						</li>
					</ul>
				</div>
				<div class="con">
					<div class="search-con">
						<el-form :inline="true" :model="searchData" class="demo-form-inline">
							<el-form-item class="el-form-item-line" label="类型">
								<el-select v-model="searchData.type" @change="changeType" placeholder="请选择类型">
									<el-option value="">请选择</el-option>
									<el-option v-for="(item, index) in typeList" :key="index" :label="item.label"
										:value="item.label">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item class="el-form-item-line" style="margin-left: 10px;">
								<el-input class="longInput" v-model="searchData.name" placeholder="输入关键字查询"></el-input>
							</el-form-item>
							<el-form-item class="el-form-item-line" style="margin-left: 10px;">
								<el-button size="large"  @click="reset">
									<el-icon class="el-icon--right"><RefreshRight /></el-icon>
									重置
								</el-button> 
								<el-button size="large"  class="addBtn" @click="add">新增</el-button>
								<el-button size="large"  class="searchBtn" @click="searchPluse">
									<el-icon class="el-icon--right"><Search /></el-icon>
									查询
								</el-button>
							</el-form-item>
						</el-form>
					</div>
					<div class="table-con consiliaTable">
						<el-table ref="multipleTable" :header-cell-style="{ background: '#f7f7f7', color: '#333' }"
							tooltip-effect="dark" style="width: 100%" :data="tableListData">
							<el-table-column align="center" label="序号" prop="seq" width="80">
							</el-table-column>
							<el-table-column align="center" label="类型" prop="type">
							</el-table-column>
							<el-table-column align="center" label="名称" prop="name">
							</el-table-column>
							<el-table-column align="center" label="操作" width="100">
								<template #default="{row}">
									<span class="editor" @click="edit(row)">
										编辑
									</span>
									<span class="del" @click="del(row)">
										删除
									</span>
								</template>
							</el-table-column>
						</el-table>
						<div class="des">
							<div class="right" style="margin-right: 0;">
								<div class="page">
									<el-pagination @current-change="handleCurrentChange" :current-page="currentPage"
										layout="prev, pager, next, jumper" :total="total" :page-size="10">
									</el-pagination>
								</div>
								<div class="data">
									共
									<span>{{ pages }}</span>页/ <span>{{ total }}</span>条记录
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="dialog">
			<el-dialog :title="addOrEdit == 'add' ? '新增药食管理' : '编辑药食管理'" v-model="addUserFlag" center>
				<div class="con">
					<el-form ref="addUserForm" :model="addUserForm" :rules="rules" label-width="80px">
						<div class="item">
							<div class="line">
								<el-form-item class="el-form-item-line" label="类型" prop="type">
									<el-select :disabled="addOrEdit == 'edit'" @change="changeAddUserFormType"
										v-model="addUserForm.type" placeholder="请选择类型">
										<el-option v-for="(item, index) in typeList" :key="index" :label="item.label"
											:value="item.label">
										</el-option>
									</el-select>
								</el-form-item>
								<el-form-item label="名称" prop="name">
									<el-input class="longInput" v-model="addUserForm.name"></el-input>
								</el-form-item>

								<div v-if="addUserForm.type == '中成药'">
									<el-form-item label="主治" prop="majorFunction">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
											class="longInput" v-model="addUserForm.majorFunction"></el-input>
									</el-form-item>
									<el-form-item label="适应症状" prop="syndromes">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
											class="longInput" v-model="addUserForm.syndromes"></el-input>
									</el-form-item>
									<el-form-item class="el-form-item-line" label="剂型" prop="dosageType">
										<el-select @change="changeDosageType" v-model="addUserForm.dosageType"
											placeholder="请选择剂型">
											<el-option v-for="(item, index) in dosageTypeList" :key="index"
												:label="item.label" :value="item.id">
											</el-option>
										</el-select>
									</el-form-item>
									<div class="dosageType" v-if="addUserForm.dosageType == 0">
										<div style="margin-top: 40px;" class="dosage-con"
											v-for="(item, index) in addUserForm.pillData" :key="index">
											<el-form-item label="剂型名称" :prop="'pillData.' + index + '.name'" :rules="{
                          required: true,
                          message: '剂型名称不能为空',
                          trigger: 'blur',
                        }">
												<el-input style="width: auto;" class="longInput" v-model="item.name">
												</el-input>
												<i @click="addPillData()" class="dosageIcon el-icon-circle-plus"></i>
												<i @click="deletePillData(index)" class="dosageIcon el-icon-remove"></i>
											</el-form-item>
											<el-form-item label="药性" :prop="'pillData.' + index + '.drugProperties'"
												:rules="{
                          required: true,
                          message: '药性不能为空',
                          trigger: 'blur',
                        }">
												<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
													class="longInput" v-model="item.drugProperties"></el-input>
											</el-form-item>
											<el-form-item label="用法用量" :prop="'pillData.' + index + '.usage'" :rules="{
                          required: true,
                          message: '用法用量不能为空',
                          trigger: 'blur',
                        }">
												<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
													class="longInput" v-model="item.usage"></el-input>
											</el-form-item>
											<el-form-item label="成份" :prop="'pillData.' + index + '.composition'"
												:rules="{
                          required: true,
                          message: '成份不能为空',
                          trigger: 'blur',
                        }">
												<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
													class="longInput" v-model="item.composition"></el-input>
											</el-form-item>
											<el-form-item label="禁忌" :prop="item.contraindication">
												<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
													class="longInput" v-model="item.contraindication"></el-input>
											</el-form-item>
										</div>
									</div>
									<div class="dosageType" v-if="addUserForm.dosageType == 1">
										<el-form-item label="药性" :prop="'pillData.' + '0' + '.drugProperties'" :rules="{
                        required: true,
                        message: '药性不能为空',
                        trigger: 'blur',
                      }">
											<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
												class="longInput" v-model="addUserForm.pillData[0].drugProperties">
											</el-input>
										</el-form-item>
										<el-form-item label="用法用量" :prop="'pillData.' + '0' + '.usage'" :rules="{
                        required: true,
                        message: '用法用量不能为空',
                        trigger: 'blur',
                      }">
											<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
												class="longInput" v-model="addUserForm.pillData[0].usage"></el-input>
										</el-form-item>
										<el-form-item label="成份" :prop="'pillData.' + '0' + '.composition'" :rules="{
                        required: true,
                        message: '成份不能为空',
                        trigger: 'blur',
                      }">
											<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
												class="longInput" v-model="addUserForm.pillData[0].composition">
											</el-input>
										</el-form-item>
										<el-form-item label="禁忌" :prop="addUserForm.pillData[0].contraindication">
											<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
												class="longInput" v-model="addUserForm.pillData[0].contraindication">
											</el-input>
										</el-form-item>
									</div>
								</div>
								<div v-if="
                    addUserForm.type == '膏方' || addUserForm.type == '颗粒剂'
                  ">
									<!-- <el-form-item class="el-form-item-line" label="适用体质" prop="physiqueId">
										<el-select :disabled="addOrEdit == 'edit'" @change="changePhysiqueType"
											v-model="addUserForm.physiqueId" placeholder="请选择类型">
											<el-option v-for="item in physiqueList" :key="item.id" :label="item.name"
												:value="item.id">
											</el-option>
										</el-select>
									</el-form-item> -->
									<el-form-item label="功效" prop="efficacy">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
											class="longInput" v-model="addUserForm.efficacy">
										</el-input>
									</el-form-item>
									<el-form-item label="配料" prop="ingredient">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
											class="longInput" v-model="addUserForm.ingredient"></el-input>
									</el-form-item>
									<el-form-item label="含量" prop="content">
										<el-input class="longInput" style="width: auto;" v-model="addUserForm.content">
											<template #suffix>
												克/袋
											</template>
										</el-input>
									</el-form-item>
									<el-form-item label="保质期" prop="shelfLife">
										<el-input class="longInput" v-model="addUserForm.shelfLife"></el-input>
									</el-form-item>
									<el-form-item label="用法" prop="usage">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
											class="longInput" v-model="addUserForm.usage"></el-input>
									</el-form-item>
									<el-form-item label="禁忌人群" prop="contraindicationOne">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
											class="longInput" v-model="addUserForm.contraindicationOne"></el-input>
									</el-form-item>
									<el-form-item label="存储条件" prop="storageCondition">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
											class="longInput" v-model="addUserForm.storageCondition"></el-input>
									</el-form-item>
								</div>
								<div v-if="addUserForm.type == '健康食品'">
									<el-form-item label="介绍" prop="introductionJKSP">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
											class="longInput" v-model="addUserForm.introductionJKSP"></el-input>
									</el-form-item>
									<el-form-item label="产品功效" prop="efficacyJKSP">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
											class="longInput" v-model="addUserForm.efficacyJKSP"></el-input>
									</el-form-item>
									<el-form-item label="产品特性" prop="characteristic">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
											class="longInput" v-model="addUserForm.characteristic"></el-input>
									</el-form-item>
									<el-form-item label="适用人群" prop="usePeople">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
											class="longInput" v-model="addUserForm.usePeople"></el-input>
									</el-form-item>
								</div>
								<el-form-item label="图片" prop="pic" v-if="addUserForm.type != '中成药'">
									<el-autocomplete  popper-class="my-autocomplete"
										v-model="addUserForm.pic" :fetch-suggestions="querySearch" placeholder="请输入内容"
										@select="handleSelect">
										<template #prefix>
										    <el-icon class="el-input__icon"><Search></Search></el-icon>
										</template>
										<template #default="{item}">
											<div class="img">
												<img :src="globalImageUrl + item.path" />
												<span class="name">{{ item.name }}</span>
											</div>
										</template>
									</el-autocomplete>
									<span class="more" style="margin-left: 10px;color: #999;">最多可选3张</span>
								</el-form-item>
								<div class="select" v-if="
                    selectedPicList.length > 0 && addUserForm.type != '中成药'
                  ">
									<ul class="select-ul">
										<li v-for="(item, index) in selectedPicList" :key="index">
											<div class="path">
												<img :src="globalImageUrl + item.path" />
											</div>
											<span class="name">{{ item.name }}</span>
										</li>
									</ul>
									<ul class="selected-ul">
										<span class="span">已选择的图片：</span>
										<div class="li">
											<li v-for="(item, index) in selectedPicList" :key="index">
												<span class="name">{{ item.name }}</span>
												<i @click="handleClose(item)" class="el-icon-circle-close">
													<CircleClose style="width:14px;float: left;margin-top: 8px;"></CircleClose>
												</i>
											</li>
										</div>
									</ul>
								</div>
								<div v-if="
                    addUserForm.type == '膏方' || addUserForm.type == '颗粒剂'
                  ">
									<el-form-item label="链接地址" prop="urlGfOrKlj">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
											class="longInput" v-model="addUserForm.urlGfOrKlj"></el-input>
									</el-form-item>
								</div>
								<div v-if="addUserForm.type == '健康食品'">
									<el-form-item label="链接地址" prop="urlJKSP">
										<el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
											class="longInput" v-model="addUserForm.urlJKSP"></el-input>
									</el-form-item>
								</div>
								<el-form-item v-if="addUserForm.type == '穴位'" class="el-form-item-line" label="视频"
									prop="video">
									<el-select @change="selectVideo" filterable v-model="addUserForm.videoId"
										placeholder="请选择视频">
										<el-option v-for="item in videoList" :key="item.title" :label="item.title"
											:value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
								<div class="select" v-if="
                    addUserForm.type == '穴位' && selectVideoList.length > 0
                  ">
									<ul class="selected-ul">
										<span class="span">已选择的视频：</span>
										<div class="li">
											<li v-for="(item, index) in selectVideoList" :key="index">
												<span class="name">{{ item.title }}</span>
												<i @click="handleVideoClose(item)" class="el-icon-circle-close">
													<CircleClose style="width:14px;float: left;margin-top: 8px;"></CircleClose>
												</i>
											</li>
										</div>
									</ul>
								</div>
							</div>
						</div>
					</el-form>
				</div>
				<template class="dialog-footer" #footer>
					<el-button size="large" @click="cancelPatient">取 消</el-button>
					<el-button size="large" class="addBtn" type="primary" @click="addPatient('addUserForm')">确 定
					</el-button>
				</template>
			</el-dialog>
		</div>
	</div>
</template>
<script>
	import globle from "../../globle/globle";
	export default {
		data() {
			return {
				total: 0,
				currentPage: 1,
				pages: 1,
				role: "",
				changeTypeName: "",
				tabList: [{
						id: 0,
						name: "饮食推荐",
					},
					{
						id: 1,
						name: "体质管理",
					},
					{
						id: 2,
						name: "选项维护",
					},
					{
						id: 3,
						name: "健康评估",
					},
					{
						id: 4,
						name: "穴位维护",
					},
					{
						id: 5,
						name: "运动健康",
					},
					{
						id: 7,
						name: "药食管理",
					},
					{
						id: 8,
						name: "图片管理",
					},
					{
						id: 9,
						name: "视频管理",
					},
				],
				currentTabIndex: 6,
				searchData: {
					name: "", //脉诊结果
					type: "膏方",
				},
				fileData: null, //文件
				fileList: [],
				fileObj: null,
				tableListData: [],
				pulseList: [],
				addUserForm: {
					type: "膏方",
					physiqueType: "",
					name: "",
					id: "",
					majorFunction: "", //主治
					syndromes: "", //适应症状
					dosageType: "", //剂型
					drugProperties: "", //药性
					composition: "", //成分
					contraindication: "", //禁忌
					pillData: [{
						name: "", //剂型名称
						drugProperties: "", //药性
						usage: "", //用法用量
						composition: "", //成分
						cpmId: "", //中成药id
						contraindication: "", //禁忌
					}, ],
					//膏方
					efficacy: "", //功效
					ingredient: "", //配料
					content: "", //含量
					shelfLife: "", //保质期
					usage: "", //用法
					contraindicationOne: "", //禁忌人群
					storageCondition: "", //储存条件
					physiqueId: "", //适用体质Id
					physique: "", //适用体质
					pic: "", //选择的图片
					videoId: "",
					urlGfOrKlj: "",
					//健康食品
					introductionJKSP: "", //介绍
					efficacyJKSP: "", //功效
					characteristic: "", //特性
					usePeople: "", //适用人群
					urlJKSP: "", //链接
				},
				rules: {
					efficacyJKSP: [{
						required: true,
						message: "请输入产品功效",
						trigger: "blur",
					}, ],
					characteristic: [{
						required: true,
						message: "请输入产品特性",
						trigger: "blur",
					}, ],
					usePeople: [{
						required: true,
						message: "请输入适用人群",
						trigger: "blur",
					}, ],
					// urlJKSP: [
					//   {
					//     required: true,
					//     message: "请输入链接",
					//     trigger: "blur",
					//   },
					// ],
					introductionJKSP: [{
						required: true,
						message: "请输入介绍",
						trigger: "blur",
					}, ],
					type: [{
						required: true,
						message: "请选择类型",
						trigger: "change",
					}, ],
					name: [{
						required: true,
						message: "请输入名称",
						trigger: "blur",
					}, ],

					majorFunction: [{
						required: true,
						message: "请输入主治",
						trigger: "blur",
					}, ],
					syndromes: [{
						required: true,
						message: "请输入适应症状",
						trigger: "blur",
					}, ],
					dosageType: [{
						required: true,
						message: "请选择剂型",
						trigger: "change",
					}, ],
					drugProperties: [{
						required: true,
						message: "请输入药性",
						trigger: "blur",
					}, ],
					usageDosage: [{
						required: true,
						message: "请输入用法用量",
						trigger: "blur",
					}, ],
					
					efficacy: [{
						required: true,
						message: "请输入功效",
						trigger: "blur",
					}, ],
					ingredient: [{
						required: true,
						message: "请输入配料",
						trigger: "blur",
					}, ],
					content: [{
						required: true,
						message: "请输入含量",
						trigger: "blur",
					}, ],
					shelfLife: [{
						required: true,
						message: "请输入保质期",
						trigger: "blur",
					}, ],
					usage: [{
						required: true,
						message: "请输入用法",
						trigger: "blur",
					}, ],
					contraindicationOne: [{
						required: true,
						message: "请输入禁忌人群",
						trigger: "blur",
					}, ],
					storageCondition: [{
						required: true,
						message: "请输入存储条件",
						trigger: "blur",
					}, ],
				},
				addOrEdit: "",
				addUserFlag: false,
				globalImageUrl: globle.imgPath,
				picList: [],
				selectedPicList: [], //被选中的图片
				isAcupointFlag: false, //是否为穴位
				isChineseMedicineFlag: false, //是否为中成药
				typeList: [

					{
						label: "膏方",
						id: "1",
					},

					{
						label: "健康食品",
						id: "3",
					},
				],
				dosageTypeList: [{
						label: "丸",
						id: "0",
					},
					{
						label: "其他剂型",
						id: "1",
					},
				],
				videoList: [],
				selectVideoList: [],
				physiqueList: [], //体质列表
			};
		},

		methods: {
			//路由切换
			goOther(index, id) {
				this.currentTabIndex = index;
				if (index == 0) {
					this.$router.push({
						path: "/knowledgeManagement/dietRecommend",
					});
				}
				if (index == 1) {
					this.$router.push({
						path: "/knowledgeManagement/constituteManagement",
					});
				}
				if (index == 2) {
					this.$router.push({
						path: "/knowledgeManagement/optionManagement",
					});
				}
				if (index == 3) {
					this.$router.push({
						path: "/knowledgeManagement/healthAssessment",
					});
				}
				if (index == 4) {
					this.$router.push({
						path: "/knowledgeManagement/physiothMainten",
					});
				}
				if (index == 5) {
					this.$router.push({
						path: "/knowledgeManagement/sportsHealth",
					});
				}
				if (index == 6) {
					this.$router.push({
						path: "/knowledgeManagement/drugManagement",
					});
				}
				if (index == 7) {
					this.$router.push({
						path: "/knowledgeManagement/picManagement",
					});
				}
				if (index == 8) {
					this.$router.push({
						path: "/knowledgeManagement/videoManagement",
					});
				}
			},
			//重置
			reset() {
				this.searchData = {
					name: "", //脉诊结果
					type: "膏方",
				}
				this.searchPluse();
			},
			//新增脉象
			add() {
				this.addUserFlag = true;
				this.addUserForm.type = "膏方";
				this.addUserForm.urlGfOrKlj = "";
				this.addUserForm.name = "";
				this.addUserForm.majorFunction = "";
				this.addUserForm.syndromes = "";
				this.addUserForm.dosageType = "";
				this.addUserForm.drugProperties = "";
				this.addUserForm.composition = "";
				this.addUserForm.contraindication = "";
				this.addUserForm.efficacy = "";
				this.addUserForm.ingredient = "";
				this.addUserForm.content = "";
				this.addUserForm.shelfLife = "";
				this.addUserForm.usage = "";
				this.addUserForm.contraindicationOne = "";
				this.addUserForm.storageCondition = "";
				this.addUserForm.physiqueId = "";
				this.addUserForm.id = "";
				this.addUserForm.videoId = "";
				this.selectedPicList = [];
				this.addOrEdit = "add";
				this.$nextTick(() => {
					this.$refs.addUserForm.clearValidate();
				});
			},
			//编辑脉象
			edit(item) {
				this.addUserForm.type = item.type;
				this.addUserForm.id = item.id;
				this.addUserForm.videoId = "";
				this.addOrEdit = "edit";
				if (item.type == "中成药") {
					this.getCpmDetail(item.id);
				}
				if (item.type == "健康食品") {
					this.getHealthFoodDetail(item.id);
				}
				if (item.type == "膏方" || item.type == "颗粒剂") {
					this.getMedicinalFoodDetail(item.id);
				}
				/* if(item.type == '穴位'){
					this.getAcupointDetail(item.id);					
				}
				
				else if(item.type != '穴位' && item.type != '中成药'){
					this.getDietDetail(item.id);
				} */
			},
			//获取膏方详情
			getMedicinalFoodDetail(id) {
				this.$applicationJson("/business/base/medicinalFood/detail", {
						id: id,
					})
					.then((res) => {
						if (res.data.code == 0) {
							let item = res.data.data;
							this.addUserForm.name = item.name;
							this.addUserForm.efficacy = item.efficacy;
							this.addUserForm.ingredient = item.ingredient;
							this.addUserForm.content = item.content;
							this.addUserForm.shelfLife = item.shelfLife;
							this.addUserForm.usage = item.usage;
							this.addUserForm.contraindicationOne = item.contraindication;
							this.addUserForm.storageCondition = item.storageCondition;
							this.addUserForm.physiqueId = Number(item.physiqueId);
							this.addUserFlag = true;
							this.addUserForm.urlGfOrKlj = item.buyUri;
							if (item.images) {
								this.selectedPicList = item.images;
							}
							if (item.videos) {
								if (item.videos.length > 0) {
									this.addUserForm.videoId = item.videos[0].id;
									this.selectVideoList = item.videos;
								}
							}
							this.$nextTick(() => {
								this.$refs.addUserForm.clearValidate();
							});
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//获取健康食品详情
			getHealthFoodDetail(id) {
				this.$applicationJson("/business/base/healthFood/detail", {
						id: id,
					})
					.then((res) => {
						// console.log("健康", res);
						if (res.data.code == 0) {
							let item = res.data.data;
							this.addUserForm.name = item.name;
							this.addUserForm.introductionJKSP = item.introduction;
							this.addUserForm.efficacyJKSP = item.efficacy;
							this.addUserForm.characteristic = item.characteristic;
							this.addUserForm.usePeople = item.applicablePopulation;
							this.addUserForm.urlJKSP = item.buyUri;
							this.addUserFlag = true;
							if (item.images) {
								this.selectedPicList = item.images;
							}
							if (item.videos) {
								if (item.videos.length > 0) {
									this.addUserForm.videoId = item.videos[0].id;
									this.selectVideoList = item.videos;
								}
							}
							this.$nextTick(() => {
								this.$refs.addUserForm.clearValidate();
							});
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//获取中成药详情
			getCpmDetail(id) {
				this.$applicationJson("/business/base/cpm/detail", {
						id: id,
					})
					.then((res) => {
						if (res.data.code == 0) {
							let item = res.data.data;
							this.addUserForm.name = item.name;
							this.isAcupointFlag = false;
							this.isChineseMedicineFlag = true;
							this.addUserForm.pic = "";
							this.selectedPicList = [];
							if (
								item.dosageType == "丸" ||
								item.dosageType == 0 ||
								item.dosageType == "0"
							) {
								this.addUserForm.dosageType = "0";
							} else {
								this.addUserForm.dosageType = "1";
							}
							this.addUserForm.majorFunction = item.majorFunction;
							this.addUserForm.syndromes = item.syndromes;
							this.addUserForm.pillData = item.details;
							this.addUserFlag = true;
							if (item.images) {
								this.selectedPicList = item.images;
							}
							if (item.videos) {
								if (item.videos.length > 0) {
									this.addUserForm.videoId = item.videos[0].id;
									this.selectVideoList = item.videos;
								}
							}
							this.$nextTick(() => {
								this.$refs.addUserForm.clearValidate();
							});
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//获取其它详情
			getDietDetail(id) {
				this.$applicationJson("/business/base/diet/detail", {
						id: id,
					})
					.then((res) => {
						if (res.data.code == 0) {
							let item = res.data.data;
							this.isAcupointFlag = false;
							this.isChineseMedicineFlag = false;
							this.addUserForm.rawMaterial = item.material;
							this.addUserForm.preparateMethod = item.method;
							this.addUserForm.usage = item.usage;
							this.addUserFlag = true;
							if (item.images) {
								this.selectedPicList = item.images;
							}
							if (item.videos) {
								if (item.videos.length > 0) {
									this.addUserForm.videoId = item.videos[0].id;
									this.selectVideoList = item.videos;
								}
							}
							this.$nextTick(() => {
								this.$refs.addUserForm.clearValidate();
							});
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//删除脉象
			del(item) {
				this.$confirm("此操作将删除该条记录, 是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
					})
					.then(() => {
						if (
							this.searchData.type == "膏方" ||
							this.searchData.type == "颗粒剂"
						) {
							this.delMedicinalFoodInfo(item.id);
						}
						if (this.searchData.type == "中成药") {
							this.delChineseMedicineInfo(item.id);
						}
						if (this.searchData.type == "健康食品") {
							this.delHealthFoodInfo(item.id);
						}
						/* else if(this.searchData.type != '穴位' && this.searchData.type != '中成药'){
						this.delUserInfo(item.id);
					} */
					})
					.catch(() => {});
			},
			//取消
			cancelPatient() {
				this.addUserFlag = false;
			},
			//确定
			addPatient(formName) {
				//this.$forceUpdate();
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.addOrEdit == "add" && this.addUserForm.type == "中成药") {
							this.addChineseMedicineInfo(); //新增中成药
						}
						if (this.addOrEdit == "edit" && this.addUserForm.type == "中成药") {
							this.editChineseMedicineInfo(); //新增中成药
						}
						if (
							this.addOrEdit == "add" &&
							(this.addUserForm.type == "膏方" ||
								this.addUserForm.type == "颗粒剂")
						) {
							this.addMedicinalFoodInfo();
						}
						if (
							this.addOrEdit == "edit" &&
							(this.addUserForm.type == "膏方" ||
								this.addUserForm.type == "颗粒剂")
						) {
							this.editMedicinalFoodInfo();
						}
						if (this.addOrEdit == "add" && this.addUserForm.type == "健康食品") {
							this.addHealthFood();
						}
						if (this.addOrEdit == "edit" && this.addUserForm.type == "健康食品") {
							this.editHealthFoodInfo();
						}
						if (this.addOrEdit == "add" && this.isAcupointFlag) {
							this.addAcupointInfo(); //新增穴位
						}
						if (this.addOrEdit == "edit" && this.isAcupointFlag) {
							this.editAcupointInfo();
						}
					} else {
						return false;
					}
				});
			},
			//新增膏方
			addMedicinalFoodInfo() {
				this.$applicationJson("/business/base/medicinalFood/add", {
						type: this.addUserForm.type,
						name: this.addUserForm.name,
						createTime: "",
						efficacy: this.addUserForm.efficacy, //功效
						ingredient: this.addUserForm.ingredient, //配料
						content: this.addUserForm.content, //含量
						shelfLife: this.addUserForm.shelfLife, //保质期
						usage: this.addUserForm.usage, //用法
						contraindication: this.addUserForm.contraindicationOne, //禁忌人群
						storageCondition: this.addUserForm.storageCondition, //储存条件
						physiqueId: this.addUserForm.physiqueId, //适用体质Id
						images: this.selectedPicList,
						id: "",
						buyUri: this.addUserForm.urlGfOrKlj,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.addUserFlag = false;
						}
						this.getMedicinalFoodList(this.currentPage);
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//新增穴位接口
			addAcupointInfo() {
				this.$applicationJson("/business/base/acupoint/add", {
						type: this.addUserForm.type,
						name: this.addUserForm.name,
						createTime: "",
						position: this.addUserForm.acupointPosition, //穴位位置
						belong: this.addUserForm.meridians, //所属经脉
						operation: this.addUserForm.acupointOperation, //穴位操作
						effect: this.addUserForm.efficacy,
						images: this.selectedPicList,
						videos: this.selectVideoList,
						id: "",
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.addUserFlag = false;
						}
						this.getMedicinalFoodList(this.currentPage);
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//新增中成药接口
			addChineseMedicineInfo() {
				this.$applicationJson("/business/base/cpm/add", {
						type: this.addUserForm.type,
						dosageType: this.addUserForm.dosageType,
						name: this.addUserForm.name,
						syndromes: this.addUserForm.syndromes, //适应症状
						majorFunction: this.addUserForm.majorFunction, //主治
						id: "",
						details: this.addUserForm.pillData,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.addUserFlag = false;
						}
						this.getChineseMedicineList(this.currentPage);
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//新增健康食品接口
			addHealthFood() {
				this.$applicationJson("/business/base/healthFood/add", {
					type: this.addUserForm.type,
					name: this.addUserForm.name,
					introduction: this.addUserForm.introductionJKSP,
					efficacy: this.addUserForm.efficacyJKSP,
					characteristic: this.addUserForm.characteristic,
					applicablePopulation: this.addUserForm.usePeople,
					images: this.selectedPicList,
					buyUri: this.addUserForm.urlJKSP,
				}).then((res) => {
					// console.log(res);
					if (res.data.code == 0) {
						this.addUserFlag = false;
						if (this.changeTypeName == "健康食品") {
							this.getHealthFoodList(this.currentPage);
						}

						this.addUserForm.type = "";
						this.addUserForm.name = "";
						this.addUserForm.introductionJKSP = "";
						this.addUserForm.efficacyJKSP = "";
						this.addUserForm.characteristic = "";
						this.addUserForm.usePeople = "";
						this.selectedPicList = "";
						this.addUserForm.urlJKSP = "";
					}
				});
			},
			//页码跳转
			handleCurrentChange(val) {
				this.currentPage = val;
				if (this.searchData.type == "膏方" || this.searchData.type == "颗粒剂") {
					this.getMedicinalFoodList(this.currentPage);
				}
				if (this.searchData.type == "健康食品") {
					this.getHealthFoodList(this.currentPage);
				}
				if (this.searchData.type == "中成药") {
					this.getChineseMedicineList(this.currentPage);
				} else if (
					this.searchData.type != "穴位" &&
					this.searchData.type != "中成药"
				) {
					this.getPlanList(this.currentPage);
				}
			},
			//编辑膏方
			editMedicinalFoodInfo() {
				this.$applicationJson("/business/base/medicinalFood/edit", {
						type: this.addUserForm.type,
						name: this.addUserForm.name,
						createTime: this.addUserForm.createTime,
						efficacy: this.addUserForm.efficacy, //功效
						ingredient: this.addUserForm.ingredient, //配料
						content: this.addUserForm.content, //含量
						shelfLife: this.addUserForm.shelfLife, //保质期
						usage: this.addUserForm.usage, //用法
						contraindication: this.addUserForm.contraindicationOne, //禁忌人群
						storageCondition: this.addUserForm.storageCondition, //储存条件
						physiqueId: this.addUserForm.physiqueId, //适用体质Id
						images: this.selectedPicList,
						id: this.addUserForm.id,
						buyUri: this.addUserForm.urlGfOrKlj,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.addUserFlag = false;
						}
						this.getMedicinalFoodList(this.currentPage);
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//编辑健康食品
			editHealthFoodInfo() {
				this.$applicationJson("/business/base/healthFood/edit", {
						type: this.addUserForm.type,
						name: this.addUserForm.name,
						introduction: this.addUserForm.introductionJKSP,
						efficacy: this.addUserForm.efficacyJKSP,
						characteristic: this.addUserForm.characteristic,
						applicablePopulation: this.addUserForm.usePeople,
						images: this.selectedPicList,
						buyUri: this.addUserForm.urlJKSP,
						id: this.addUserForm.id,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.addUserFlag = false;
						}
						this.getHealthFoodList(this.currentPage);
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//编辑其它接口
			editUserInfo() {
				this.$applicationJson("/business/base/diet/edit", {
						type: this.addUserForm.type,
						name: this.addUserForm.name,
						createTime: this.addUserForm.createTime,
						material: this.addUserForm.rawMaterial,
						method: this.addUserForm.preparateMethod,
						usage: this.addUserForm.usage,
						images: this.selectedPicList,
						id: this.addUserForm.id,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.addUserFlag = false;
						}
						this.getPlanList(this.currentPage);
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//编辑中成药
			editChineseMedicineInfo() {
				this.$applicationJson("/business/base/cpm/edit", {
						type: this.addUserForm.type,
						dosageType: this.addUserForm.dosageType,
						name: this.addUserForm.name,
						syndromes: this.addUserForm.syndromes, //适应症状
						majorFunction: this.addUserForm.majorFunction, //主治
						id: this.addUserForm.id,
						details: this.addUserForm.pillData,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.addUserFlag = false;
						}
						this.getChineseMedicineList(this.currentPage);
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//删除膏方
			delMedicinalFoodInfo(id) {
				let ids = [];
				ids.push(id);
				this.$applicationJson("/business/base/medicinalFood/delete", {
						ids: ids,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.$message({
								type: "success",
								message: "删除成功!",
							});
						}
						this.getMedicinalFoodList(this.currentPage);
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//删除健康食品
			delHealthFoodInfo(id) {
				let ids = [];
				ids.push(id);
				this.$applicationJson("/business/base/healthFood/delete", {
						ids: ids,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.$message({
								type: "success",
								message: "删除成功!",
							});
						}
						this.getHealthFoodList(this.currentPage);
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//删除穴位
			delAcupointInfo(id) {
				let ids = [];
				ids.push(id);
				this.$applicationJson("/business/base/acupoint/delete", {
						ids: ids,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.$message({
								type: "success",
								message: "删除成功!",
							});
							this.currentPage = 0;
						}
						this.getMedicinalFoodList(this.currentPage);
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//删除中成药
			delChineseMedicineInfo(id) {
				let ids = [];
				ids.push(id);
				this.$applicationJson("/business/base/cpm/delete", {
						ids: ids,
					})
					.then((res) => {
						if (res.data.code == 0) {
							this.$message({
								type: "success",
								message: "删除成功!",
							});
						}
						this.getChineseMedicineList(this.currentPage);
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//搜索
			searchPluse() {
				if (this.searchData.type == "膏方" || this.searchData.type == "颗粒剂") {
					this.getMedicinalFoodList(this.currentPage);
				}
				if (this.searchData.type == "健康食品") {
					this.getHealthFoodList(0);
				}else{
					this.getMedicinalFoodList(this.currentPage);
				}
				/* if (this.searchData.type == "中成药") {
					this.getChineseMedicineList(0);
				} else {
					this.getPlanList(0);
				} */
				this.currentPage = 0;
			},
			//获取脉象列表
			getPlanList(currentPage) {
				this.$applicationJson("/business/base/diet/paging", {
						current: currentPage,
						orderBy: "",
						params: {
							name: this.searchData.name,
							type: this.searchData.type,
						},
						size: 10,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.tableListData = res.data.data.records;
							for (let i = 0; i < this.tableListData.length; i++) {
								this.tableListData[i].seq = Number(i) + 1;
							}
							this.total = res.data.data.total;
							this.pages = res.data.data.pages;
							//this.currentPage = 0;
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//获取膏方颗粒剂
			getMedicinalFoodList(currentPage) {
				this.$applicationJson("/business/base/medicinalFood/paging", {
						current: currentPage,
						orderBy: "",
						params: {
							name: this.searchData.name,
							type: this.searchData.type,
						},
						size: 10,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.tableListData = res.data.data.records;
							for (let i = 0; i < this.tableListData.length; i++) {
								this.tableListData[i].seq = Number(i) + 1;
							}
							this.total = res.data.data.total;
							this.pages = res.data.data.pages;
							this.currentPage = res.data.data.current;
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//获取健康食品
			getHealthFoodList(currentPage) {
				this.$applicationJson("/business/base/healthFood/paging", {
						current: currentPage,
						orderBy: "",
						params: {
							name: this.searchData.name,
							type: this.searchData.type,
						},
						size: 10,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.tableListData = res.data.data.records;
							for (let i = 0; i < this.tableListData.length; i++) {
								this.tableListData[i].seq = Number(i) + 1;
							}
							this.total = res.data.data.total;
							this.pages = res.data.data.pages;
							this.currentPage = res.data.data.current;
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//获取中成药列表
			getChineseMedicineList(currentPage) {
				this.$applicationJson("/business/base/cpm/paging", {
						current: currentPage,
						orderBy: "",
						params: {
							name: this.searchData.name,
							type: this.searchData.type,
						},
						size: 10,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.tableListData = res.data.data.records;
							for (let i = 0; i < this.tableListData.length; i++) {
								this.tableListData[i].seq = Number(i) + 1;
								/* if(this.tableListData[i].type == 0){
									this.tableListData[i].type = '丸类'
								}
								if(this.tableListData[i].type == 1){
									this.tableListData[i].type = '其他'
								} */
							}
							this.total = res.data.data.total;
							this.pages = res.data.data.pages;
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//获取图片列表
			getImageList(currentPage) {
				this.$applicationJson("/business/base/image/paging", {
						current: currentPage,
						orderBy: "",
						params: {
							name: "",
						},
						size: 1000,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.picList = res.data.data.records;
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			querySearch(queryString, cb) {
				var picList = this.picList;
				var results = queryString ?
					picList.filter(this.createFilter(queryString)) :
					picList;
				// 调用 callback 返回建议列表的数据
				cb(results);
			},
			//图片搜索
			createFilter(queryString) {
				return (picList) => {
					return (
						picList.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0
					);
				};
			},
			//图片选择
			handleSelect(item) {
				this.selectedPicList.push(item);
				if (this.selectedPicList.length == 2) {
					return false;
				}
			},
			//图片关闭
			handleClose(tag) {
				this.selectedPicList.splice(this.selectedPicList.indexOf(tag), 1);
			},
			//视频关闭
			handleVideoClose(tag) {
				this.addUserForm.videoId = "";
				this.selectVideoList.splice(this.selectVideoList.indexOf(tag), 1);
			},
			//搜索切换类型
			changeType(val) {
				this.changeTypeName = val;
				if (val == "中成药") {
					this.getChineseMedicineList(0);
				}
				if (val == "膏方" || val == "颗粒剂") {
					this.getMedicinalFoodList(0);
				}
				if (val == "健康食品") {
					this.getPlanList(0);
					this.getHealthFoodList(0);
				}
				else{
					this.getMedicinalFoodList(0);
				}
				this.currentPage = 0;
			},
			//新增修改切换类型
			changeAddUserFormType(val) {
				this.addUserForm.name = "";
				this.addUserForm.rawMaterial = "";
				this.addUserForm.preparateMethod = "";
				this.addUserForm.usage = "";
				this.addUserForm.pic = "";
				this.addUserForm.acupointPosition = "";
				this.addUserForm.meridians = "";
				this.addUserForm.acupointOperation = "";
				this.addUserForm.efficacy = "";
				this.addUserForm.type = val;
				if (val == "中成药") {
					this.isChineseMedicineFlag = true;
					this.isAcupointFlag = false;
					this.searchData.type = "中成药";
				}
				/* if (val == '穴位') {
					this.isAcupointFlag = true;
					this.isChineseMedicineFlag = false;					
					this.searchData.type = "穴位";
					this.$refs.addUserForm.clearValidate('name')
					this.$refs.addUserForm.clearValidate('rawMaterial')
					this.$refs.addUserForm.clearValidate('preparateMethod')
					this.$refs.addUserForm.clearValidate('usage')
				}
				else if(val != '穴位' && val != '中成药'){
					this.isAcupointFlag = false;
					this.isChineseMedicineFlag = false;					
					this.searchData.type = "";
					this.$refs.addUserForm.clearValidate('name')
					this.$refs.addUserForm.clearValidate('acupointPosition')
					this.$refs.addUserForm.clearValidate('meridians')
					this.$refs.addUserForm.clearValidate('acupointOperation')
					this.$refs.addUserForm.clearValidate('efficacy')
				} */
			},
			//切换中成药丸和其他类型
			changeDosageType() {
				this.addUserForm.pillData = [{
					name: "", //剂型名称
					drugProperties: "", //药性
					usage: "", //用法用量
					composition: "", //成分
					cpmId: "", //中成药id
					contraindication: "", //禁忌
				}, ];
			},
			//切换体质
			changePhysiqueType(val) {
				this.addUserForm.physiqueId = val;
			},
			//新增丸数据
			addPillData() {
				if (this.addUserForm.pillData == undefined) {
					this.addUserForm.pillData = [];
				}
				let obj = {
					name: "", //剂型名称
					drugProperties: "", //药性
					usage: "", //用法用量
					composition: "", //成分
					cpmId: "", //中成药id
					contraindication: "", //禁忌
				};
				this.addUserForm.pillData.push(obj);
			},
			//删除丸数据
			deletePillData(index) {
				//alert(index)
				this.addUserForm.pillData.splice(index, 1);
			},
			//保存丸数据
			surePillData(index) {},
			//选择视频
			selectVideo(id) {
				this.selectVideoList = [];
				for (let i = 0; i < this.videoList.length; i++) {
					if (this.videoList[i].id == id) {
						this.selectVideoList.push(this.videoList[i]);
					}
				}
			},
			//获取视频列表
			getVideoList(page) {
				this.$applicationJson("/business/shutcm/video/paging", {
						orderBy: null,
						orderType: 1, //0正序  1倒序
						page: 0,
						pageSize: 100,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.videoList = res.data.data.records;
						}
					})
					.catch((Error) => {
						//this.$message.error('网络异常');
					});
			},
			//获取体质列表
			getPhysiqueList(currentPage) {
				this.$applicationJson("/business/base/physique/paging", {
						current: currentPage,
						orderBy: "",
						params: {
							name: this.searchData.name,
						},
						size: 100,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.physiqueList = res.data.data.records;
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
		},
		created() {
			this.$nextTick(() => {
				let loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
				let role = loginInfo.role;
				this.role = role;
				if (role == 1) {
					this.tabList.splice(0, 5);
				}
				this.getImageList(0);
				//this.getChineseMedicineList(0);
				this.searchPluse()
				this.getVideoList();
				this.getPhysiqueList(0);
			});
		},
	};
</script>

<style lang="less" scoped="scoped">
	@import "../../../static/css/layout.less";
	@import "../../../static/css/mentor.less";

	.independent-wrapper {
		.content {
			.contentLeft {
				width: 100%;
				height: calc(100% - 40px);

				.con {
					min-height: calc(100% - 80px);

					.search-con {
						height: 120px;
						@media screen and (min-width: 1076px) and (max-width: 1920px) {
							height: 60px;
							width: 100%;
						}
					}
				}
			}

			.about {
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				overflow: hidden;
			}

			.demo-form-inline {
				margin-top: 10px;

				:deep(.el-input__inner){
					width: 220px;
				}
			}

			.editor {
				cursor: pointer;
				color: #679ff6;
			}

			.del {
				color: #df6d78;
				cursor: pointer;
				margin-left: 10px;
			}

		}
	}

	.dialog {
		:deep(.el-dialog__body){
			padding: 0;

			.con {
				margin-top: 30px;
				padding: 0 5px;
				width: calc(100% - 10px);
				overflow-y: auto;
				padding-bottom: 30px;
				min-height: 500px;

				.item {
					.line {
						width: 100%;
						overflow: hidden;

						&:nth-child(1) {
							margin-bottom: 20px;
						}

						.el-form-item {
							width: 100%;
						}

						.dosageIcon {
							font-size: 16px;
							color: #666;
							margin-left: 10px;
							cursor: pointer;
						}

						.dialog-tit {
							height: 40px;
							line-height: 40px;

							span {
								float: left;
								font-size: 16px;
								margin-bottom: 20px;
								overflow: hidden;
								width: 100%;
								color: #333;
							}

							.border {
								background-color: rgba(103, 159, 246, 1);
								width: 3px;
								height: 14px;
								margin-top: 13px;
								position: absolute;
								left: 0px;
							}
						}
					}
				}

				.longInput {
					width: 100%;

					:deep(.el-input__inner){
						width: 100%;
					}
				}

				.smallInput {
					width: 150px;

					:deep(.el-input__inner) {
						width: 100%;
					}
				}
			}
		}
	}

	.img {
		margin-bottom: 10px;
		float: left;

		img {
			float: left;
			width: 40px;
		}

		span {
			float: left;
			margin-left: 10px;
			width: calc(100% - 50px);
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			-o-text-overflow: ellipsis;
		}
	}

	.select {
		margin-left: 40px;
		width: calc(100% - 40px);

		ul {
			float: left;
			width: 100%;
			margin-bottom: 20px;

			li {
				float: left;
				width: 120px;
				text-align: center;

				.path {
					img {
						width: 40px;
						margin-left: 40px;
						max-height: 40px;
					}

					width: 40px;
					height: 40px;
				}

				span {
					margin-left: 10px;
					width: calc(100% - 50px);
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
					-o-text-overflow: ellipsis;
					display: inline-block;
				}
			}
		}

		.selected-ul {
			float: left;
			width: 100%;
			margin-left: 40px;

			.span {
				float: left;
				width: 100px;
				line-height: 30px;
			}

			.li {
				float: left;
				width: calc(100% - 110px);

				li {
					border: 1px solid #eee;
					line-height: 30px;
					margin-right: 10px;
					width: auto;
					padding: 0 10px;

					span {
						width: 80px;
						float: left;
						line-height: 30px;
						overflow: hidden;
						white-space: nowrap;
						text-overflow: ellipsis;
						-o-text-overflow: ellipsis;
					}

					i {
						cursor: pointer;
						margin-left: 8px;
						color: #333;
						float: left;
						line-height: 30px;
					}
				}
			}
		}
	}
</style>
